// Leesbare veldnamen voor de history-dialoog vanuit planning-detail (DvdS). Gaat vóór de
// labels uit common-entity-fields.ts, die technisch zijn ("Entity ID") maar elders gebruikt worden.
export const PLANNING_HISTORY_LABELS: Record<string, string> = {
    user_id: 'Gebruiker',
    driver_user_id: 'Chauffeur',
    entity_id: 'Materieel',
    truck_entity_id: 'Vrachtwagen',
    lowloader_entity_id: 'Dieplader',
    performer_id: 'Uitvoerder',
    mechanic_id: 'Monteur',
    hiring_id: 'Inhuur',
    planning_has_id: 'Hoofdplanning',
    planning_id: 'Planning',
    entitytype_key: 'Soort materieel',
    afas_project_id: 'AFAS-project',
    afas_customer_id: 'Klant',
    leave_id: 'Verlof',
    work_begin: 'Werk begin',
    work_end: 'Werk einde',
    origin: 'Vertreklocatie',
    destination: 'Bestemming',
    type: 'Type vzw',
};
